var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-2"},[_c('v-card',[_c('v-card-text',{style:({ height: _vm.contentHeight + 'px' })},[_c('a-table-f-api',{ref:"table",attrs:{"api":_vm.url,"model":_vm.model,"useQuery":true,"defaults":{}}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }